import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { WrapMeWith } from "@/common/components/wrap-me-with/wrap-me-with";

import { BindingOfferDialog } from "./binding-offer-dialog";

type BindingOfferBuyDialogProps = {
  traderName: string;
  cropName: string;
  amount: string;
  quarter: string;
  postalCodeLabel: string;
  parameters?: string;
  unitPrice: string;
  tocUrl?: string | null;
  isPending: boolean;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferBuyDialog = ({
  postalCodeLabel,
  tocUrl,
  ...props
}: BindingOfferBuyDialogProps) => {
  return (
    <BindingOfferDialog
      {...props}
      confirmLabel={<Trans>Koupit</Trans>}
      introText={
        <Trans>
          Kupující tímto činí závazný návrh na uzavření kupní smlouvy o nákupu
          zboží v reakci na rámcovou nabídku prodávajícího, a to za
          následujících podmínek:
        </Trans>
      }
      legalConsentText={
        <Trans>
          Nakupující souhlasí s tím, že obsah kupní smlouvy se bude řídit{" "}
          <WrapMeWith
            when={!!tocUrl}
            wrapper={(children) => (
              <a
                className="text-can-forest-teal underline"
                href={tocUrl!}
                rel="noreferrer"
                target="_blank"
              >
                {children}
              </a>
            )}
          >
            obchodními podmínkami
          </WrapMeWith>
          .
        </Trans>
      }
      legalNoticeText={
        <Trans>
          Kupující bere na vědomí, že prodávající nemá povinnost tento návrh
          akceptovat. Kupní smlouva vzniká konfirmací tohoto závazného návrhu ze
          strany prodávajícího.
        </Trans>
      }
      parity={t`CPT - naložený dopravní prostředek ${postalCodeLabel}`}
      traderLabel={t`Prodávající`}
    />
  );
};

export { BindingOfferBuyDialog };
